// Conversion factors for FBA
// Converts field to metric
// Multiply field value by the conversion factor to obtain the metric value
export const fbaConversionFactors = {
  c_f: (14.6956 / 101.325024),
  formationCompressibility: (14.6956 / 101.325024),
  gor: (6.29 / 35.3),
  cgr: (35.3 / 6.29),
  gwr: (6.29 / 35.3),
  p_fi: (101.325024 / 14.6956),
  pSep: (101.325024 / 14.6956),
  pbtMatrixInflow: (101.325024 / 14.6956),
  h: 0.305,
  r_w: 0.305,
  halfLength: 0.305,
  totalXFBBT: 0.305,
  totalXFMatrixInflow: 0.305,
  id: 25.4,
  w_f: 25.4,
  roughness: 25.4,
  rB: (6.29 / 35.3),
  midPointPerfs: 0.305,
  fractureConductivityLFTC: 0.305,
  fc: 0.305,
  fractureConductivity: 0.305,
  fractureConductivityPreBT: 0.305,
  loadFluidPumped: 0.159,
  drainageAreaPreBT: (43560 / Math.pow(3.28, 2)),
  drainageAreaPostBT: (43560 / Math.pow(3.28, 2)),
  fractureArea: (43560 / Math.pow(3.28, 2)),
  fip: 0.159,
  fractureSpacingMatrixInflow: 0.305,
  oil: 0.159,
  condensate: 0.159,
  gas: 0.0283,
  water: 0.159,
  pwh: (101.325024 / 14.6956),
  pwf: (101.325024 / 14.6956),
  simulatorPbar: (101.325024 / 14.6956),
  gasPbarLinear: (101.325024 / 14.6956),
  rnp: 43.36775,
  qDmp: 1 / (6.2898107704 * 101.325024 / 14.6956),
  linearFlowFitIntercept: (6.2898107704 * 101.325024 / 14.6956),
  linearFlowFitInterceptI: (6.2898107704 * 101.325024 / 14.6956),
  fractureDepletionFitIntercept: (6.2898107704 * 101.325024 / 14.6956),
  fractureDepletionFitInterceptI: (6.2898107704 * 101.325024 / 14.6956),
  // linearFlowFitIntercept: ((101.325024 / 14.6956) / 0.159),
  // linearFlowFitInterceptI: ((101.325024 / 14.6956) / 0.159),
  // fractureDepletionFitIntercept: ((101.325024 / 14.6956) / 0.159),
  // fractureDepletionFitInterceptI: ((101.325024 / 14.6956) / 0.159),
  multiPhaseFitIntercept: (6.29 / 35.3),
  sqrtTimeFitSlope: (101.325024 / 14.6956),
  sqrtTimeFitIntercept: (6.2898107704 * 101.325024 / 14.6956),
  // sqrtTimeFitSlope: (0.159 * 101.325024 / 14.6956),
  // sqrtTimeFitIntercept: (0.159 * 101.325024 / 14.6956),
  fmbFitSlope: 1 / (101.325024 / 14.6956),
  fmbFitIntercept: 1 / (6.2898107704 * 101.325024 / 14.6956)
};